<template>
    <b-container class="pl-0 pr-0 mb-6">
        <b-col lg="12" class="no-gutters">
            <h3 class="resource-title mb-5">{{ $t('info.donation_target_question')}}</h3>
        </b-col>
        <b-col lg="12" class="no-gutters">
        <b-row>
              <!-- Charity -->
              <b-col xl="4" lg="6" md="6" class="ml-auto mx-auto mb-4">
                  <div class="card category-container box-shadow" v-bind:class="{'category-selected': selected === CHARITY}" @click.stop="setCategory(CHARITY)">

                      <div class="category-icon-container">
                          <hand-holding-heart v-bind:iconStyle="'large'" v-bind:topIconSize="'3x'" v-bind:bottomIconSize="'5x'"/>
                      </div>
                      <span class="category-info-text">
                          {{ $t('categories.1') }}
                      </span>
                  </div>
              </b-col>
              <!-- Environment -->
              <b-col xl="4" lg="6" md="6" class="ml-auto mx-auto mb-4">
                  <div class="card category-container box-shadow" v-bind:class="{ 'category-selected': selected === ENV}" @click.stop="setCategory(ENV)">
                      <div class="category-icon-container">
                          <hand-holding-globe v-bind:iconStyle="'large'"  v-bind:topIconSize="'3x'" v-bind:bottomIconSize="'5x'"/>
                      </div>
                      <span class="category-info-text">
                          {{ $t('categories.2') }}
                      </span>
                  </div>
              </b-col>
              <b-col xl="4" lg="6" md="6" class="ml-auto mx-auto mb-4">
                  <div class="card category-container box-shadow" v-bind:class="{'category-selected': selected === SPORTS}" @click.stop="setCategory(SPORTS)">
                      <div class="category-icon-container">
                          <hand-holding-basketball v-bind:iconStyle="'large'" v-bind:topIconSize="'3x'" v-bind:bottomIconSize="'5x'"/>
                      </div>
                      <span class="category-info-text">
                          {{ $t('categories.4') }}
                      </span>
                  </div>
              </b-col>
          </b-row>
        </b-col>
      </b-container>
</template>

<script>
    import HandHoldingHeart from "@/components/icons/HandHoldingHeart";
    import HandHoldingGlobe from "@/components/icons/HandHoldingGlobe";
    import HandHoldingBasketball from "@/components/icons/HandHoldingBasketball";
    export default {
        name: "category-feed",
        components: {HandHoldingBasketball, HandHoldingGlobe, HandHoldingHeart},
        data() {
            return {
                CHARITY: 1,
                ENV: 2,
                SCHOOLS: 3,
                SPORTS: 4,
                selected: -1,
                results: null,
                nearTeam: [],
                loading: false
            }
        },
        methods: {
            scrollBack () {
                let offset = window.innerWidth*0.7;
                this.$refs.scroller.scrollLeft = this.$refs.scroller.scrollLeft-offset
            },

            scrollAhead () {
                let offset = window.innerWidth*0.7;
                this.$refs.scroller.scrollLeft = this.$refs.scroller.scrollLeft+offset
            },

            setCategory: function (category) {
                this.selected = category
                this.$emit('onCategorySet', category)
            }
        }
    }
</script>

<style scoped>
</style>
